import React from "react";
import PropTypes from "prop-types";

import UserInfo from "../../../UserInfo";

const RequiredUserType = ({
  children,
  allowedUserType,
  userType = UserInfo.groupId,
}) => {
  if (!Number.isNaN(userType)) {
    const isUserAllowed = allowedUserType.includes(Number.parseInt(userType));

    return isUserAllowed && children;
  }
};

RequiredUserType.propTypes = {
  userType: PropTypes.number,
  allowedUserType: PropTypes.array,
  children: PropTypes.node,
};

export default RequiredUserType;
